import { useEffect, useState } from 'react';
var TOP_OF_SCREEN = 0;
// Arbitrary amount to keep the element off from the top of the screen when resetting
var TOP_OF_SCREEN_BUFFER = 50;
var disableWindowScroll = function () {
    window.scrollTo(0, TOP_OF_SCREEN);
};
var disableBodyScroll = function () {
    window.scrollTo(0, TOP_OF_SCREEN);
    window.addEventListener('scroll', disableWindowScroll);
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '0px';
    document.body.style.width = '100%';
};
var enableBodyScroll = function () {
    window.removeEventListener('scroll', disableWindowScroll);
    document.body.style.overflow = null;
    document.body.style.position = null;
    document.body.style.width = null;
};
export default function useLockScreen(shouldLockScreen, wrapperRef) {
    var _a = useState(0), elementScrollPosition = _a[0], setElementScrollPosition = _a[1];
    var _b = useState(false), isScreenLocked = _b[0], setIsScreenLocked = _b[1];
    /*
     * This function will handle the enable/disable scrolling
     */
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        if (shouldLockScreen && elementScrollPosition > TOP_OF_SCREEN) {
            disableBodyScroll();
            setIsScreenLocked(true);
        }
        if (!shouldLockScreen && isScreenLocked) {
            setIsScreenLocked(false);
            // unregister the listerner
            return function () {
                enableBodyScroll();
                window.scrollTo(0, elementScrollPosition - TOP_OF_SCREEN_BUFFER);
            };
        }
    }, [elementScrollPosition, shouldLockScreen, isScreenLocked]);
    useEffect(function () {
        if (wrapperRef) {
            var element = wrapperRef.current;
            var rect = element.getBoundingClientRect();
            setElementScrollPosition(rect.top);
        }
    }, [wrapperRef]);
}
